import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import RequestsPage from './pages/RequestsPage';
import FeasibilityCheck from './pages/FeasibilityCheck';
import NegotiationPage from './pages/NegotiationPage';
import OrderExecution from './pages/OrderExecution';
import ResultsDelivery from './pages/ResultsDelivery';
import SettingsPage from './pages/SettingsPage';
import HelpSupportPage from './pages/HelpSupportPage';
import ProfileManagementPage from './pages/ProfileManagementPage';
import DataMappingWizard from './pages/DataMappingWizard';
import NetworkTab from './pages/NetworkTab';
import LoginPage from './auth/LoginPage';
import { AuthProvider } from './auth/authContext';
import ProtectedRoute from './auth/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Öffentliche Route für Login */}
          <Route path="/login" element={<LoginPage />} />
          
          {/* Geschützte Routen */}
          <Route path="/" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/incoming-requests" element={
            <ProtectedRoute>
              <RequestsPage />
            </ProtectedRoute>
          } />
          <Route path="/feasibility-check" element={
            <ProtectedRoute>
              <FeasibilityCheck />
            </ProtectedRoute>
          } />
          <Route path="/negotiation" element={
            <ProtectedRoute>
              <NegotiationPage />
            </ProtectedRoute>
          } />
          <Route path="/order-execution" element={
            <ProtectedRoute>
              <OrderExecution />
            </ProtectedRoute>
          } />
          <Route path="/results-delivery" element={
            <ProtectedRoute>
              <ResultsDelivery />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } />
          <Route path="/help" element={
            <ProtectedRoute>
              <HelpSupportPage />
            </ProtectedRoute>
          } />
          <Route path="/profile-management" element={
            <ProtectedRoute>
              <ProfileManagementPage />
            </ProtectedRoute>
          } />
          <Route path="/data-mapping" element={
            <ProtectedRoute>
              <DataMappingWizard />
            </ProtectedRoute>
          } />
          <Route path="/network" element={
            <ProtectedRoute>
              <NetworkTab />
            </ProtectedRoute>
          } />
          
          {/* Standardroute zum Login umleiten */}
          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
